<template>
  <span
    :class="[
      'inline-flex items-center px-2 py-1 rounded-sm text-xs font-medium ring-1 ring-inset',
      value ? 'bg-[#f0f4e8] text-[#3d5218] ring-[#5c7a2e]/20' : 'bg-red-50 text-red-700 ring-red-600/20'
    ]"
  >
    {{ value ? yes : no }}
  </span>
</template>

<script>
export default {
  name: "YesNoLabel",
  props: {
    value: {
      default: false
    },
    yes: {
      default: "Sí"
    },
    no: {
      default: "No"
    }
  }
};
</script>
